'use strict';
var userAgent = require('../internals/engine-user-agent');

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-ios-pebble.js
// module id = 515
// module chunks = 0